function setCustomerReportData(data) {
	return {
		type: 'SET_CUSTOMER_REPORT',
		payload: data,
	};
}


export { setCustomerReportData };
